export default "__VITE_ASSET__CmwDVUB0__"